import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../../utils/api';

// Create an API thunk for fetching data
export const SaveLtJobs = createApi('api/admin/saveLtJob', 'POST');

const SaveAndRun = createSlice({
  name: 'SaveAndRun',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SaveLtJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(SaveLtJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(SaveLtJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SaveAndRun.reducer;